import {coleccion_de_libro_diario, numeración_de_documentos} from '@/FirebaseConfig'
import Vue from 'vue'
import Vuex from 'vuex'
export default {
    namespaced:true,
    state: {
        movimiento_contable: {
            nombre: '',
            reglas: []
        },       
        cargando: true,
        registro: [],
        selectedKey: '',
        cantidad_de_registros: 0,
    },
    actions: {
        obtener_todo: ({state, commit}, event)=>{
            const {itemsPerPage, page} = event
            let ref = coleccion_de_libro_diario
            if(state.cantidad_de_registros > 0 ) ref = ref.where('numeracion', '<=', state.cantidad_de_registros - itemsPerPage * (page-1) )
            ref.limit(itemsPerPage).orderBy("numeracion", "desc").onSnapshot(collection=>{
                const colección = []
                collection.docs.map( item => colección.push({ ...item.data(), id: item.id }) )
                state.registro = colección
                state.cargando = false
            })
            numeración_de_documentos.collection('Nota contable').doc('00').onSnapshot( doc=> state.cantidad_de_registros = doc.exists ? doc.data().numeracion : 0 )
           
        }
    },
    getters: {
        registro: state =>{
         let f =   Object.keys(state.registro).map(item => ({...state.registro[item], key: item }))
         f.sort((a, b)=>b.numeracion-a.numeracion)
         return f
        }
    }
}